import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "16", x: "6", y: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "16", x: "14", y: "4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Pause";
const Pause = memo(themed(Icon));
export {
  Pause
};
//# sourceMappingURL=pause.js.map
